export default __webpack_public_path__ + "static/media/jayde_darin.7decd93f.png";